import {
    Component,
    OnInit,
    TemplateRef,
    ViewChild,
    ViewContainerRef,
} from '@angular/core';
import { SiteServices } from '../../services/siteservices';
import { Router } from '@angular/router';
import { ProviderContext } from '../../data/Entities';

import { BsModalService } from 'ngx-bootstrap/modal';
import { BsModalRef } from 'ngx-bootstrap/modal';
import { setTimeout } from 'timers';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Helpers } from '../../services/Helpers';

declare var jQuery: any;

@Component({
    selector: 'categoryblocklistapp',
    templateUrl: '/templates/get/CategoryBlock/categoryblock_list',
})
export class CategoryBlockList implements OnInit {
    public current_row: any;

    public dtx: ProviderContext;
    public rows: any = [];
    
    onlyActive: boolean = true;

    constructor(
        public siteServices: SiteServices,
        private modalService: BsModalService,
        public viewRef: ViewContainerRef,
        private router: Router,
        private http: HttpClient
    ) {
        this.dtx = new ProviderContext({
            ProviderCode: 'CATEGORYBLOCK',
            SortField: 'Title',
            IsAsc: false,
        });

        this.refresh(true);
    }

    public ngOnInit() {
        this.siteServices.onChangeDetail.subscribe((prod) => {
            if (!prod) return;
            let dx = Helpers.findKeyNdx(
                this.rows,
                prod.CategoryBlockID,
                'CategoryBlockID'
            );
            if (dx >= 0) {
                if (prod._deleted) {
                    this.rows.splice(dx, 1);
                } else this.rows[dx] = prod;
            } else this.rows.splice(0, 0, prod);
        });
    }

    public refresh(needCount: boolean) {
        this.rows = [];
        this.dtx.clearFilter();

        if (this.onlyActive){
            this.dtx.addFilter('Active', this.onlyActive.toString());    
        }

        this.siteServices.provider_GetPage(this.dtx, (data) => {
            this.rows = data.TagObject;
            this.dtx.TotalItems = data.Tag;
        });
    }

    public pageChanged(ev) {
        this.dtx.Page = ev.page;
        this.refresh(false);
    }

    public onSort(_sortField) {
        if (this.dtx.SortField === _sortField) {
            this.dtx.IsAsc = !this.dtx.IsAsc;
        } else {
            this.dtx.SortField = _sortField;
            this.dtx.IsAsc = true;
        }
        this.refresh(false);
    }

    public onSortChange($ev) {
        //console.log($ev);
        const arr = $ev.target.value.split(' ');
        this.dtx.SortField = arr[0];
        this.dtx.IsAsc = arr.length === 1;

        this.dtx.SortField2 = arr[2];
        this.dtx.IsAsc2 = arr.length === 1;

        //console.log(this.dtx);
        // this.refresh(false);
    }

    public edit(id) {
        this.router
            .navigate(['categoryblockedit', id, Helpers.GetTicks()])
            .then((_ev) => {});
    }
}
